import { useTranslation } from "react-i18next"
import { Grid, Typography, FormControlLabel, Divider, Checkbox } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import { red, orange } from "@material-ui/core/colors";

const DeviceSetupFromTitle = ({isNewVersion, newVersion, config, setConfig, groupData, toUpdate, setToUpdate}) => {
    var {t} = useTranslation();

    const handleUpdateToNew = (event) => {
    setToUpdate(event.target.checked);

    if (event.target.checked) {
        if (parseInt(newVersion?.version_current) >= 202) {
        if (config?.device_setting?.misc?.mains_filter == 0) {
            setConfig({
            ...config,
            device_setting: {
                ...config?.device_setting,
                misc: { ...config?.device_setting?.misc, mains_filter: 1 },
            },
            });
        }
        }

        if (parseInt(newVersion?.version_current) >= 203) {
        setConfig({
            ...config,
            device_setting: {
            ...config?.device_setting,
            misc: { ...config?.device_setting?.misc, alert_warning: 1 },
            },
        });
        }
    }};

    return (<>
        <Grid item xs={12}>
            <Alert severity="info" color="warning">
                {t("devices.setUp.info.onlyConnectedDevices")}
            </Alert>
        </Grid>
        <Grid container  item xs={12} lg={12} xl={12}>
            <Grid item xs={12} >
                <Typography variant="h3" color="textSecondary">
                    {groupData?.name}
                </Typography>
            </Grid>
            <Divider style={{ width: "100%", marginTop: 10, marginBottom: 0 }}></  Divider>
        </Grid>
        {isNewVersion && newVersion?.is_available && (
            <Grid container item xs={12} alignItems="center">
            <Grid item style={{ paddingRight: 10 }}>
                <NewReleasesIcon fontSize="large" style={{ color: orange[500] }}></NewReleasesIcon>
            </Grid>
            <Grid item>
                <FormControlLabel control={<Checkbox checked={toUpdate} onClick={handleUpdateToNew} name="checkedB" color="primary" />} label={t("devices.setUp.info.update_opt")} />
            </Grid>
            </Grid>
        )}
    </>)
};

export default DeviceSetupFromTitle;